import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Tabs, TabContainer } from '@gpstrackit/gtc-react-controls';
import AssetsOpenDefects from './views/assetsOpenDefects';
import OpenDefectDetails from './views/openDefectDetails';
import RepairsReport from './views/repairsReport';
import './DefectsGTC.scss';

const TAB_ASSETS = 0;
const TAB_REPAIRS = 1;

const DefectsGtc = () => {
  const { messages } = useIntl();
  const [activeTab, setActiveTab] = useState(TAB_ASSETS);
  const [selectedAsset, setSelectedAsset] = useState(null);

  const handleTabChange = (newValue) => {
    setActiveTab(newValue);
    setSelectedAsset(null);
  };

  const handleViewDefects = (assetId) => {
    const asset = { id: assetId }; // In real app, would fetch asset details
    setSelectedAsset(asset);
  };

  const handleBackFromDetails = () => {
    setSelectedAsset(null);
  };

  // If viewing defect details for a specific asset
  if (selectedAsset && activeTab === TAB_ASSETS) {
    return (
      <div className="DefectsGTC">
        <OpenDefectDetails
          assetId={selectedAsset.id}
          assetFleet={selectedAsset.fleet}
          onBack={handleBackFromDetails}
        />
      </div>
    );
  }

  return (
    <div className="DefectsGTC">
      <Tabs tab={activeTab} onChange={handleTabChange}>
        <TabContainer
          label={messages['assetsWithDefects'] || 'Assets with Defects'}
          index={TAB_ASSETS}
        >
          <AssetsOpenDefects onViewDefects={handleViewDefects} />
        </TabContainer>
        <TabContainer
          label={messages['repairs'] || 'Repairs'}
          index={TAB_REPAIRS}
        >
          <RepairsReport />
        </TabContainer>
      </Tabs>
    </div>
  );
};

export default DefectsGtc;
